import "clsx";
import { P as Pricing } from "../../../../../chunks/Pricing.js";
function _page($$renderer) {
  Pricing($$renderer);
}
export {
  _page as default
};
